<template>
<tr :id="'searchTableRow-tRow-' + caseObj.policycaseHeaderId">

  <td class="font-weight-bold" :id="'searchTableRow-tData-' + caseObj.policycaseHeaderId">
    <router-link v-bind:to="'/case/' + caseObj.policycaseHeaderId" :id="'searchTableRow-anchor-' + caseObj.policycaseHeaderId">
      {{ caseObj.policycaseHeaderId }}
    </router-link>
  </td>

  <td>{{ caseObj.policycaseHeaderUniqueId }}</td>

  <td>{{ caseObj.customerUniqueId }}</td>

  <td>{{ getDescriptionByName(caseObj.productLineName) }}</td>

  <td>{{ caseObj.status | translate('status') }}</td>

  <td>{{ caseObj.batchID }}</td>

  <td>{{ commaSeparatedCovers }}</td>

  <td>
    <policy-card-mini :summary="caseObj.requested" :insurers="insurers"></policy-card-mini>
  </td>
  <td>
    <div class="minicards-flex">
      <policy-card-mini v-for="response in caseObj.responses"
                          :key="response.insurer"
                          :summary="response"
                          :insurers="insurers"
        ></policy-card-mini>
    </div>
  </td>

</tr>
</template>

<script>
import PolicyCardMini from '@/components/case/PolicyCardMini';
import CustomIcon from '@/components/CustomIcon';

export default {
  components: { PolicyCardMini, CustomIcon },
  data() {
    return {
    };
  },
  props: ['caseObj', 'insurers', 'productLines'],
  computed: {
    commaSeparatedCovers() {
      return this.caseObj.requested.covers
        .map(cover => this.$options.filters.translate(cover, 'cover.short'))
        .join(', ');
    }
  },
  methods: {
    getDescriptionByName(name) {
      for (let item of this.productLines) {
        if (item.name === name) {
          return item.description;
        }
      }
      return '-';
    }
  }
}
</script>

<style lang="scss" scoped>
.productline-icon {
  width: 80px;
  fill: $primary;
}
</style>



// WEBPACK FOOTER //
// src/components/cases/SearchTableRow.vue